import { HiOutlineInformationCircle } from 'react-icons/hi'

import { Alert, AlertProps, Box, Icon } from '@chakra-ui/react'

import { AiOperatorModelT, Criterion } from '../types/types'

interface DefaultModelAlertIProps extends AlertProps {
  criteria: Criterion[]
  defaultAiOperatorModel?: AiOperatorModelT | null
  isImplementer?: boolean
}

export const DefaultModelAlert = ({
  criteria,
  defaultAiOperatorModel,
  isImplementer = false,
  ...props
}: DefaultModelAlertIProps) => {
  if (!isImplementer || !defaultAiOperatorModel) {
    return null
  }

  const defaultCount = criteria.filter((c) => !c.aiOperatorModelId).length

  if (defaultCount === 0) {
    return null
  }

  const pluralText = defaultCount === 1 ? 'criterion' : 'criteria'
  const message = `${defaultCount} ${pluralText} using the default model (currently `

  return (
    <Alert
      bg='#DBE9FE'
      borderRadius='10px'
      color='#1D40B0'
      mb={4}
      status='info'
      {...props}
    >
      <Icon
        as={HiOutlineInformationCircle}
        boxSize='20px'
        color='#1D40B0'
        mr='10px'
      />
      <Box fontSize='13px' fontWeight={400}>
        {message}
        <Box as='span' fontWeight={500}>
          {defaultAiOperatorModel.canonicalName}
        </Box>
        )
      </Box>
    </Alert>
  )
}
